// assets/lieferhinweis.js
import { Component } from '@theme/component';

/**
 * Lieferhinweis pro Variante.
 *
 * - Liest die Zuordnung Varianten-ID -> Hinweistext aus einem JSON-Script im Block.
 * - Zeigt den Hinweis, sobald die aktuell gewählte Variante einen Text hat.
 * - Schickt den Text als sichtbare Bestell-Eigenschaft „Lieferhinweis“ mit.
 * - Reagiert auf Variantenwechsel per MutationObserver auf input[name="id"]
 *   (Horizon-unabhängig) sowie change am Produktformular.
 *
 * @extends Component
 */
class Lieferhinweis extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.sectionId = this.dataset.sectionId;
    this.productForm = document.getElementById('BuyButtons-ProductForm-' + this.sectionId);
    this.map = this.#readJson('[data-lieferhinweis-map]') || {};
    this.variantInput =
      (this.productForm && this.productForm.querySelector('input[name="id"]')) ||
      document.querySelector('input[name="id"]');

    this.#update();

    if (this.variantInput) {
      this.observer = new MutationObserver(this.#onChange);
      this.observer.observe(this.variantInput, { attributes: true, attributeFilter: ['value'] });
    }
    if (this.productForm) this.productForm.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.observer?.disconnect();
    if (this.productForm) this.productForm.removeEventListener('change', this.#onChange);
  }

  #readJson(selector) {
    const el = this.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('[Lieferhinweis] JSON konnte nicht gelesen werden:', error);
      return null;
    }
  }

  #onChange = () => this.#update();

  /** Hinweis der aktuell gewählten Variante zeigen/verstecken + Property setzen. */
  #update() {
    const id = this.variantInput?.value;
    const text = (id && this.map[id]) || '';
    const { box, message, propInput } = this.refs;

    if (text) {
      if (message) message.textContent = text;
      if (box) box.hidden = false;
      if (propInput) {
        propInput.disabled = false;
        propInput.value = text;
      }
    } else {
      if (box) box.hidden = true;
      if (propInput) {
        propInput.disabled = true;
        propInput.value = '';
      }
    }
  }
}

if (!customElements.get('lieferhinweis-component')) {
  customElements.define('lieferhinweis-component', Lieferhinweis);
}
